import React from "react";
import { AlertTriangleIcon, ClockIcon, HelpCircleIcon, BrainIcon, RotateCcwIcon, CompassIcon, ArrowRightIcon, BoxIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { painPoints, practiceLoop, PainIcon } from "../data/content";
const iconMap: Record<PainIcon, BoxIcon> = {
  alert: AlertTriangleIcon,
  clock: ClockIcon,
  help: HelpCircleIcon,
  brain: BrainIcon,
  rewind: RotateCcwIcon,
  compass: CompassIcon
};
export function PainPoints() {
  return <section className="bg-white px-4 py-16 sm:py-24" aria-labelledby="pain-title" data-id="element-203" data-mp="21zcxisu9sptg">
      <div className="mx-auto max-w-5xl" data-id="element-204" data-mp="21x06lq6jb549">
        <h2 id="pain-title" className="text-center font-serif text-3xl font-bold leading-tight text-ink sm:text-5xl" data-id="element-205" data-mp="1o0dafpmeoize">
          Do any of these situations <em className="text-wine-700" data-id="element-206" data-mp="1t0r7kcmgy8in">sound familiar?</em>
        </h2>
        <p className="mt-4 text-center text-[17px] text-ink-soft sm:text-lg" data-id="element-207" data-mp="3iewa7kfkc8dq">If you answer YES to any of them, this system was created for you.</p>

        <ul className="mt-10 grid gap-4 md:grid-cols-2" data-id="element-208" data-mp="1z0orgnycznep">
          {painPoints.map(({
          icon,
          text
        }) => {
          const Icon = iconMap[icon];
          return <li key={text} className="flex gap-4 rounded-2xl border border-wine-100 bg-wine-50/60 p-5" data-id="element-209" data-mp="1tzhjansb0m7i">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-wine-700 text-white" data-id="element-210" data-mp="27utc2pmwg2ls">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-211" data-mp="1g1j5bjhwarsj" />
                </span>
                <p className="text-[16px] leading-snug text-ink" data-id="element-212" data-mp="1b2pu5xq2zcvj">{text}</p>
              </li>;
        })}
        </ul>

        <div className="mx-auto mt-14 max-w-3xl text-center" data-id="element-213" data-mp="1p30juxfnmlf4">
          <p className="text-lg text-ink-soft" data-id="element-214" data-mp="1p0een4g8ki02">And the problem may not be that you need more information.</p>
          <p className="mt-2 font-serif text-2xl font-bold text-ink sm:text-3xl" data-id="element-215" data-mp="1k5qwrofqmlug">
            You may need a <em className="text-wine-700" data-id="element-216" data-mp="30jh5x9lps0ay">different way to train it.</em>
          </p>
          <p className="mt-6 text-[17px] leading-relaxed text-ink-soft" data-id="element-217" data-mp="2vknpp9f1lv73">
            Biomechanics isn't learned only by reading. It also develops through practice. You need opportunities to:
          </p>

          <ol className="mt-6 flex flex-wrap items-center justify-center gap-x-1.5 gap-y-3" data-id="element-218" data-mp="1y6cg613ihkzz">
            {practiceLoop.map((step, i) => <li key={step} className="flex items-center gap-1.5" data-id="element-219" data-mp="274o4txkti8ps" data-mpi={i}>
                <span className="rounded-full bg-wine-900 px-4 py-2 text-sm font-bold text-white" data-id="element-220" data-mp="272tuteb3410h">{step}</span>
                {i < practiceLoop.length - 1 && <ArrowRightIcon className="h-4 w-4 text-wine-500" aria-hidden="true" data-id="element-221" data-mp="1efqxgpi59wbt" />}
              </li>)}
          </ol>

          <div className="mt-10 rounded-3xl bg-cream p-6 text-left sm:p-8" data-id="element-222" data-mp="1jek35vr6wj1f">
            <p className="font-serif text-xl font-bold text-wine-900 sm:text-2xl" data-id="element-223" data-mp="1o6lkhw37szyb">That's why I created BIOMECHANICS WAR ROOM™.</p>
            <p className="mt-3 text-[17px] leading-relaxed text-ink-soft" data-id="element-224" data-mp="qpwlea5ngbsm">
              I didn't want to create another textbook filled with theory. I wanted to create a training environment where you could face challenging cases, make your own analysis first, and then compare your reasoning with a structured explanation.
            </p>
          </div>
        </div>

        <div className="mt-12" data-id="element-225" data-mp="e7atg8db1s6s">
          <CtaButton label="I want access to the War Room" data-id="element-226" data-mp="e6hkd0qviqlh" />
        </div>
      </div>
    </section>;
}